import { type api, isDefined } from 'common';

import { useSelectedNodeField } from '../../../../ConfigFields/useSelectedNodeField';
import { getDefaultSchedulingConfigs } from '../utils';

export function useSchedulingConfigsField(fieldNamePrefix: string) {
  const { setValue, ...args } =
    useSelectedNodeField<api.FlowDefinition.FormBlockConfig['schedulingConfigs']>(fieldNamePrefix);

  const setSchedulingConfigs = (
    value?: Partial<api.FlowDefinition.FormBlockConfig['schedulingConfigs']>
  ) => {
    if (!isDefined(value)) {
      return setValue(getDefaultSchedulingConfigs());
    }

    setValue({
      ...getDefaultSchedulingConfigs(),
      ...args.value,
      ...value,
    });
  };

  return {
    ...args,
    value: args.value,
    setValue: setSchedulingConfigs,
  };
}
